var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14H9.16664M2.16663 14.3334L5.86614 12.9105C6.10277 12.8195 6.22108 12.774 6.33177 12.7146C6.43009 12.6618 6.52383 12.6009 6.61199 12.5324C6.71124 12.4554 6.80088 12.3658 6.98015 12.1865L14.5 4.66671C15.2364 3.93033 15.2364 2.73642 14.5 2.00004C13.7636 1.26366 12.5697 1.26366 11.8333 2.00004L4.31348 9.51985C4.13421 9.69912 4.04457 9.78876 3.96755 9.88801C3.89914 9.97617 3.83823 10.0699 3.78545 10.1682C3.72603 10.2789 3.68053 10.3972 3.58951 10.6339L2.16663 14.3334ZM2.16663 14.3334L3.53871 10.766C3.63689 10.5107 3.68598 10.3831 3.77019 10.3246C3.84377 10.2735 3.93483 10.2542 4.02282 10.271C4.12351 10.2902 4.22021 10.3869 4.41361 10.5803L5.91967 12.0864C6.11307 12.2798 6.20977 12.3765 6.229 12.4772C6.24581 12.5652 6.22648 12.6562 6.17539 12.7298C6.11692 12.814 5.98928 12.8631 5.73401 12.9613L2.16663 14.3334Z",
    stroke: "#101828",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.041e8541ef091d8da19fb8bbaf43f278.svg";
export { ForwardRef as ReactComponent };